import { trackClientEvent, TrackClientEventFunc } from "./event-factory";

// Important notes for this file:
// - Use snake case: signup_button_click instead of signupButtonClick
// - Only use lowercase letters
// - Use present-tense verbs: "submit" instead of "submitted"
// - Keep events in alphabetical order
// - For event names, follow the `category:object_action` framework: For example, account_settings:password_updated or signup_flow:create_account

export const trackClientAgenticToolMessageSend: TrackClientEventFunc<{
  tool: string;
  org_id: string | null;
}> = (p) => trackClientEvent({ event: "agentic_tool_message_send", ...p });

export const trackClientAuthAcceptToken: TrackClientEventFunc<{
  action: string;
}> = (p) => trackClientEvent({ event: "auth_accept_token", ...p });

export const trackClientBrandSafetyReportCheck: TrackClientEventFunc<{
  creator: string;
  requester: string;
}> = (p) => trackClientEvent({ event: "brand_safety_report_check", ...p });

export const trackClientChatFeedbackCopyToClipboard: TrackClientEventFunc<
  Record<string, never>
> = (p) => trackClientEvent({ event: "chat_feedback_copy_to_clipboard", ...p });

export const trackClientChatFeedbackThumbsDown: TrackClientEventFunc<
  Record<string, never>
> = (p) => trackClientEvent({ event: "chat_feedback_thumbs_down", ...p });

export const trackClientChatFeedbackThumbsUp: TrackClientEventFunc<
  Record<string, never>
> = (p) => trackClientEvent({ event: "chat_feedback_thumbs_up", ...p });

export const trackClientCreatorMatchCardClick: TrackClientEventFunc<{
  creator_name: string;
  creator_uuid: string;
}> = (p) => trackClientEvent({ event: "creator_match_card_click", ...p });

export const trackClientCreatorMatchSaveCreatorButtonClick: TrackClientEventFunc<{
  creator_name: string;
  creator_id: string;
  saved: boolean;
}> = (p) =>
  trackClientEvent({ event: "creator_match_save_creator_button_click", ...p });

export const trackClientCreatorMenuSentViaInvalidEmailFallback: TrackClientEventFunc<{
  invite_slug: string;
  creator_id: string;
}> = (p) =>
  trackClientEvent({
    event: "creator_menu_sent_via_invalid_email_fallback",
    ...p,
  });

export const trackClientCreatorOnboardingFlow: TrackClientEventFunc<{
  invite_slug: string;
  step: string;
  action?: string;
  creator_name?: string;
  creator_id?: string;
  service?: string;
}> = (p) => trackClientEvent({ event: "creator_onboarding_flow", ...p });

export const trackClientCreatorSubmittedContent: TrackClientEventFunc<{
  creator_name: string;
  creator_uuid: string;
  deal_memo: string | null;
  deal_memo_id: string | null;
  deal_memo_deliverable_ids: string;
  deal_memo_deliverable_name: string | null;
}> = (p) => trackClientEvent({ event: "creator_content_submit", ...p });

export const trackClientDealMemoStatusUpdate: TrackClientEventFunc<{
  deal_memo_id: number;
  deal_memo_title: string | null;
  new_status: string;
  old_status: string;
}> = (p) => trackClientEvent({ event: "deal_memo_status_update", ...p });

export const trackClientSubmitContent: TrackClientEventFunc<{
  action?: string;
  creator_name?: string;
  creator_uuid?: string;
}> = (p) => trackClientEvent({ event: "submit_content", ...p });
